import { render, staticRenderFns } from "./product-order-thumbnail.vue?vue&type=template&id=91f8190a&"
import script from "./product-order-thumbnail.vue.ts?vue&type=script&lang=ts&"
export * from "./product-order-thumbnail.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports